import wrappersTypes from '../constants/wrappers-types';

const getRelatedClassName = (tagName) => {
  const wrappersType = Object.values(wrappersTypes).find((type) => type.tagName === tagName);

  return wrappersType && wrappersType.className;
};

export default getRelatedClassName;
